import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="pt-40 pb-32 min-h-[70vh] flex items-center justify-center" data-testid="payment-cancel-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="max-w-lg mx-auto px-6 text-center">
        <XCircle size={56} className="mx-auto mb-6 text-[#71717A]" />
        <h1 className="font-serif text-4xl font-light mb-3">Checkout cancelled</h1>
        <p className="text-[#71717A] mb-10">No charge was made. Your cart is still saved — you can complete checkout whenever you're ready.</p>
        <div className="flex gap-3 justify-center">
          <Link to="/checkout" data-testid="cancel-retry" className="inline-flex items-center gap-2 bg-[#D4AF37] text-black px-6 py-3 font-mono text-[11px] uppercase tracking-[0.2em] hover:bg-[#C5A028] transition-colors">Return to checkout</Link>
          <Link to="/" className="inline-flex items-center gap-2 border border-zinc-700 px-6 py-3 font-mono text-[11px] uppercase tracking-[0.2em] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">Keep browsing</Link>
        </div>
      </motion.div>
    </main>
  );
}
